import React from "react";
import { MapPin, Phone, Mail, Linkedin, Facebook, Twitter } from "lucide-react";
import { company, navLinks, products } from "../../mock";
import LogoMark from "./LogoMark";

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 lg:px-6 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="bg-white rounded-xl inline-flex p-3 shadow-sm">
            <LogoMark size={56} />
          </div>
          <p className="mt-5 text-[14px] text-slate-400 leading-relaxed max-w-md">
            A leading manufacturer of industrial &amp; lab-grade acids since {company.established} — supplying pharma, textile, steel and water-treatment industries across India.
          </p>
          <div className="flex items-center gap-2 mt-6">
            {[Linkedin, Facebook, Twitter].map((Icon, i) => (
              <a key={i} href="#" aria-label="social" className="h-9 w-9 rounded-lg border border-white/10 bg-white/5 hover:bg-teal-600 hover:border-teal-500 flex items-center justify-center transition-colors">
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="text-white font-display font-bold mb-4">Company</div>
          <ul className="space-y-2.5 text-[14px]">
            {navLinks.map((l) => (
              <li key={l.href}><a href={l.href} className="hover:text-teal-300 transition-colors">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-white font-display font-bold mb-4">Products</div>
          <ul className="space-y-2.5 text-[14px]">
            {products.map((p) => (
              <li key={p.slug}><a href="#products" className="hover:text-teal-300 transition-colors">{p.name} <span className="text-slate-500">({p.formula})</span></a></li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-white font-display font-bold mb-4">Reach Us</div>
          <ul className="space-y-3 text-[13.5px]">
            <li className="flex items-start gap-2.5"><MapPin className="h-4 w-4 mt-0.5 text-teal-300 shrink-0" /><span>{company.address.line1}, {company.address.line2}, {company.address.state}</span></li>
            <li className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-teal-300" /><a href={`tel:${company.phone.replace(/\s/g, "")}`} className="hover:text-teal-300">{company.phone}</a></li>
            <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-teal-300" /><a href={`mailto:${company.email}`} className="hover:text-teal-300">{company.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-[12.5px] text-slate-500">
          <div>© {new Date().getFullYear()} {company.legalName}. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-teal-300">Privacy Policy</a>
            <a href="#" className="hover:text-teal-300">Terms of Use</a>
            <a href="#" className="hover:text-teal-300">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
